import axios from "axios";

export default async function uploadThemeAsset(token, file, assetName) {
  if (file.size > 4 * 1024 * 1024) {
    throw new Error("Size of the pdf should be under 4MB");
  }

  let formData = new FormData();
  formData.append("file", file);
  const resp = await axios.post(
    `${process.env.REACT_APP_ORGANISER_API}/webpage/theme-asset/upload/${assetName}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        token,
      },
    }
  );

  // console.log(resp);
  if (!resp.data) {
    throw new Error(resp.error.message);
  }
  if (resp.error) {
    throw new Error(resp.error);
  }
  return resp.data.url;
}
